import React from 'react';
import { Box } from '@mui/material';
import { TabPanelProps } from './types';

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => (
  <div role="tabpanel" hidden={value !== index}>
    {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
  </div>
);

export default TabPanel;
